import { IOmniaSession } from "./types";

let usersnapApi: any

export function setupUsersnap(key: string) {

    window["onUsersnapCXLoad"] = function(api) {
        api.init({
            button: { isHidden: true }
        });
        usersnapApi = api
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://widget.usersnap.com/load/' + key + '?onload=onUsersnapCXLoad';

    document.getElementsByTagName('head')[0].appendChild(script);

}

export function reportFeedback(session: IOmniaSession) {

    function report() {

        const api = usersnapApi

        api.on("open", function(event) {

            const { holdingId, holding, yearId, currentUser: user } = session

            const data = {
                holdingId,
                holdingName: holding ? holding.TradingName : null,
                cropYear: yearId,
                user: {
                    userId: user?.Id,
                    email: user?.Email
                },
                language: navigator.language,
            }

            event.api.setValue("custom", data)

        })

        api.open()

    }

    report()

}
